import React, {useState, Fragment} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado,} from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';

const EditarValorDeLaTarifa = ({title, openFullScreenDialog, handleClose, medioDeComunicacion, datosTarifario, validarTipoDeTarifario, accionTarifaEditada}) => {
    const dispatch = useDispatch();
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);

    const [camposDelFormulario] = React.useState({
        mes: {
            idelement: "mes",  value: datosTarifario.mes, label: "Mes", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"julio", 'disabled': true, width: '50%',
        },
        tarifa: {
            idelement: "tarifa",  value: datosTarifario.valorDeTarifa, label: "Valor de la tarifa *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"tarifa", 'disabled': false, width: '50%',
        },
        acciones: {
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const guardarDatos = async (datosDelFormulario) => {
        setcargandoSolicitud(true);

        const { tarifa } = datosDelFormulario;

        const controllerMedio = validarTipoDeTarifario();

        const datosAEnviar = {
            controller: controllerMedio, action: "editar",
            data: { },
            nombreDelMetodo: `editar/tarifario/${medioDeComunicacion?.id || ""}/${datosTarifario?.id || ""}/${tarifa || ""}`
        };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));

        setcargandoSolicitud(false);
        if(respuesta?.error) return setResponseData('error', `${respuesta?.error}` || "Ocurrió un inconveniente. Intente de nuevo!", true)

        accionTarifaEditada(respuesta?.data)
    }

    const [listaDeBotones]= React.useState({
        "guardarDatos":{"label":"Guardar datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,})
    const { errorType, messageType, openResponse} = responseData;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            maxWidth="md"
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={camposDelFormulario}
                            buttonList={listaDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default EditarValorDeLaTarifa;